<nav class="left-nav" [class.collapsed]="sb.collapsed">
  <div class="nav-body">
    @for (section of navSections(); track section.id) {
      <div class="nav-item" [class.open]="hasChildren(section.id) && openSection === section.id">
        <div class="nav-item-header"
             [class.flat]="!hasChildren(section.id)"
             [class.active]="hasChildren(section.id) ? openSection === section.id : isRouteActive(section.route)"
             (click)="toggleSection(section.id)">
          {{ section.label }}
          @if (hasChildren(section.id)) {
            <svg class="nav-item-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          }
        </div>
        <div class="nav-item-body">
          <!-- @if (section.id === 'rate-sheets') {
          
            <div class="sb-sec">
              <div class="si"
                   [class.a]="router.url === '/rate-sheet'"
                   (click)="router.navigateByUrl('/rate-sheet')">
                <div>
                  <div class="si-n">MYGA Rate Sheet</div>
                  <div class="si-m">FA fixed rates · All carriers</div>
                </div>
              </div>
              <div class="si"
                   [class.a]="router.url === '/ia-rate-sheet'"
                   (click)="router.navigateByUrl('/ia-rate-sheet')">
                <div>
                  <div class="si-n">Index Rate Sheet</div>
                  <div class="si-m">IA indexed rates · All carriers</div>
                </div>
              </div>
              <div class="si"
                   [class.a]="router.url === '/rila-rate-sheet'"
                   (click)="router.navigateByUrl('/rila-rate-sheet')">
                <div>
                  <div class="si-n">RILA Rate Sheet</div>
                  <div class="si-m">Structured annuity rates · All carriers</div>
                </div>
              </div>
              @for (sheet of sb.companySheets(); track sheet.id) {
                <div class="si"
                     [class.a]="sb.activeSheetId === sheet.id"
                     (click)="selectCompanySheet(sheet)">
                  <div>
                    <div class="si-n">{{ sheet.name }}</div>
                    <div class="si-m">{{ sheet.subtitle }}</div>
                  </div>
                  <svg class="si-lock" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <rect x="3" y="11" width="18" height="11" rx="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </div>
              }
            </div>
          } -->
          @if (section.id === 'rates') {
            <!-- Type Switcher -->
            <div class="type-sw">
              @for (t of typeButtons; track t.key) {
                <div class="type-sw-btn"
                     [class.ac]="sb.activeType() === t.key"
                     [style.font-size]="t.key === 'all' ? '8px' : null"
                     (click)="selectType(t.key)">{{ t.label }}</div>
              }
            </div>

            <!-- My Views — saved views only. Standard rate sheets +
                 company spreadsheets moved to the RATE SHEETS section. -->
            <div class="sb-sec">
              <div class="sb-lbl sb-lbl-toggle" (click)="myViewsExpanded = !myViewsExpanded">
                <span class="sb-lbl-chev">{{ myViewsExpanded ? '▾' : '▸' }}</span>
                My Views
              </div>
              @if (myViewsExpanded) {
                @for (sheet of currentMineSheets; track sheet.id) {
                  <div class="si"
                       [class.a]="sb.activeSheetId === sheet.id"
                       (click)="selectSheet(sheet.id, sheet.type)">
                    <div>
                      <div class="si-n">{{ sheet.name }}</div>
                      <div class="si-m">{{ sheet.subtitle }}</div>
                    </div>
                    <div class="si-kebab">&#x22EE;</div>
                  </div>
                }
              }
            </div>
          }
          @if (section.id === 'products') {
            <!-- Product Search link -->
            <div class="sb-sec">
              <div class="si"
                   [class.a]="router.url.split('?')[0] === '/products'"
                   (click)="router.navigateByUrl('/products')">
                <div>
                  <div class="si-n">Product Search</div>
                  <div class="si-m">Browse all products</div>
                </div>
              </div>
            </div>
          }
          @if (section.id === 'calculator') {
            <div class="calc-form" style="padding: 0 8px 8px;">
              <div class="sb-new">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
                New Calculation
              </div>
            </div>
          }
          @if (section.id === 'sales') {
            <div class="calc-form" style="padding: 0 8px 8px;">
              @for (tab of salesTabs; track tab.key) {
                <div class="si" [class.a]="activeSalesTab === tab.key"
                     style="padding: 5px 6px 5px 16px; border-radius: 4px; cursor: pointer; font-size: 12px; font-weight: 600; color: var(--text2);"
                     (click)="navigateToSalesTab(tab.key)">{{ tab.label }}</div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- Bottom dark-pill stack: Case Scenarios → Inbox → Basket.
       Each pill shares the dark-bg theme. Light dividers between them.
       The basket is the only one that expands a panel (in
       <app-selection-tray />); when it does, the pills above it are
       pushed up by the panel naturally, since they're DOM siblings. -->
  <div class="bottom-pill" [class.active]="isOnRoute('/broker/cases')" (click)="goTo('/broker/cases')">
    <span class="bottom-pill-label">CASE SCENARIOS</span>
    <span class="bottom-pill-chev">▸</span>
  </div>
  <div class="bottom-pill" [class.active]="isOnRoute('/inbox')" (click)="goTo('/inbox')">
    <span class="bottom-pill-label">INBOX</span>
    <span class="bottom-pill-chev">▸</span>
  </div>
  <app-selection-tray />

  <!-- Collapsed icon rail. Mirrors the expanded sidebar's nav structure but
       in a 52px-wide strip, so collapse becomes "focus mode" instead of
       "hide mode" — every section + every utility stays one click away. -->
  @if (sb.collapsed) {
    <div class="rail-body">
      @for (section of navSections(); track section.id) {
        <button class="rail-ico"
                type="button"
                [class.active]="hasChildren(section.id) ? openSection === section.id : isRouteActive(section.route)"
                [title]="section.label"
                (click)="toggleSection(section.id)">
          <span class="rail-abbr">{{ abbrFor(section.id, section.label) }}</span>
        </button>
      }

      <div class="rail-sep"></div>

      <button class="rail-ico" type="button"
              [class.active]="isOnRoute('/broker/cases')"
              title="Case Scenarios"
              (click)="goTo('/broker/cases')">
        <span class="rail-abbr">CS</span>
      </button>
      <button class="rail-ico" type="button"
              [class.active]="isOnRoute('/inbox')"
              title="Inbox"
              (click)="goTo('/inbox')">
        <span class="rail-abbr">IN</span>
      </button>
      <button class="rail-ico rail-basket" type="button"
              title="Basket"
              (click)="sb.toggleSidebar()">
        <span class="rail-abbr">BK</span>
        @if (basketCount() > 0) { <span class="rail-pip">{{ basketCount() }}</span> }
      </button>
    </div>
  }

  <!-- Splitter Pill -->
  <div class="splitter" (click)="sb.toggleSidebar()" title="Click to collapse/expand"></div>
</nav>
